<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M5.5 14H3.25A1.25 1.25 0 012 12.75V10.5a1 1 0 012 0V12h1.5a1 1 0 010 2zM3 6.5a1 1 0 01-1-1V3.25A1.25 1.25 0 013.25 2H5.5a1 1 0 010 2H4v1.5a1 1 0 01-1 1zM13 6.5a1 1 0 01-1-1V4h-1.5a1 1 0 010-2h2.25A1.25 1.25 0 0114 3.25V5.5a1 1 0 01-1 1zM12.75 4zM12.75 14H10.5a1 1 0 010-2H12v-1.5a1 1 0 012 0v2.25A1.25 1.25 0 0112.75 14zM9.75 11h-3.5A1.25 1.25 0 015 9.75v-3.5A1.25 1.25 0 016.25 5h3.5A1.25 1.25 0 0111 6.25v3.5A1.25 1.25 0 019.75 11zM7 9h2V7H7z"/></svg>